import {
  AccountId,
  InvoiceId,
  PermissionId,
  ProjectId,
  UserId,
} from 'api/models';
import { unreachable } from 'utils/unreachable';

export type UserPresenceChannel = ['user_presence_channel', AccountId];
export const UserPresenceChannel = (id: AccountId): UserPresenceChannel => [
  'user_presence_channel',
  id,
];

export type ProjectChannel = [
  'project_channel',
  AccountId,
  PermissionId,
  ProjectId,
];
export const ProjectChannel = (
  a: AccountId,
  b: PermissionId,
  c: ProjectId,
): ProjectChannel => ['project_channel', a, b, c];

export type AccountChannel = ['account_channel', AccountId, PermissionId];
export const AccountChannel = (
  accountId: AccountId,
  permissionId: PermissionId,
): AccountChannel => ['account_channel', accountId, permissionId];

export type RevenueEntryOverviewChannel = [
  'revenue_entry_overview_channel',
  AccountId,
  PermissionId,
];
export const RevenueEntryOverviewChannel = (
  accountId: AccountId,
  permissionId: PermissionId,
): RevenueEntryOverviewChannel => [
  'revenue_entry_overview_channel',
  accountId,
  permissionId,
];

export type UserChannel = ['user_channel', UserId, AccountId];
export const UserChannel = (
  accountId: AccountId,
  userId: UserId,
): UserChannel => ['user_channel', userId, accountId];

export type ProjectPresenceChannel = [
  'project_presence_channel',
  AccountId,
  ProjectId,
];
export const ProjectPresenceChannel = (
  accountId: AccountId,
  projectId: ProjectId,
): ProjectPresenceChannel => ['project_presence_channel', accountId, projectId];

export type InvoiceChannel = [
  'invoice_channel',
  AccountId,
  PermissionId,
  InvoiceId,
];
export const InvoiceChannel = (
  a: AccountId,
  b: PermissionId,
  c: InvoiceId,
): InvoiceChannel => ['invoice_channel', a, b, c];

export type ChannelInfo =
  | ProjectChannel
  | UserPresenceChannel
  | AccountChannel
  | RevenueEntryOverviewChannel
  | UserChannel
  | ProjectPresenceChannel
  | InvoiceChannel;

export const name = (channel: ChannelInfo): string => {
  switch (channel[0]) {
    case 'user_presence_channel':
      return `presence-accountId@${channel[1][1]}`;
    case 'user_channel':
      return `private-accountId@${channel[2][1]}-userId@${channel[1][1]}`;
    case 'project_channel':
      return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}-projectId@${channel[3][1]}`;
    case 'account_channel':
      return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}`;
    case 'revenue_entry_overview_channel':
      return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}-REVENUE_ENTRY_OVERVIEW_PRIVATE_CHANNEL`;
    case 'project_presence_channel':
      return `presence-accountId@${channel[1][1]}-projectId@${channel[2][1]}`;
    case 'invoice_channel':
      return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}-invoiceId@${channel[3][1]}`;
    default:
      return unreachable(channel);
  }
};
